import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-[70vh] flex items-center pt-32"
    >
      <div className="container-page">
        <p className="eyebrow mb-4">404 · Page not found</p>
        <h1 className="font-display text-6xl md:text-8xl font-extrabold tracking-tighter leading-none">
          Nothing here.
        </h1>
        <p className="mt-6 text-[#4B5563] text-lg max-w-xl">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <Link
          to="/"
          data-testid="return-home"
          className="inline-flex items-center gap-2 mt-10 shine box-elevated bg-[#0B1220] text-white px-6 py-3 text-sm font-semibold hover:bg-[#1E5AF6] transition-colors"
        >
          Return home
        </Link>
      </div>
    </div>
  );
}
